import { styled } from '@/styles/stitches.config';
import { ComposableStyledComponentProps } from '@/types/composable-styled-component';
import React, { useCallback, useState } from 'react';
import { usePopper } from 'react-popper';

export type TooltipProps = ComposableStyledComponentProps<HTMLDivElement> & {
  children: React.ReactNode;
  options?: Parameters<typeof usePopper>[2];
  root: Parameters<typeof usePopper>[0];
};

const TooltipRoot = styled('div', {
  background: '$white',
  borderRadius: '$space$5',
  paddingBlock: '$4',
  paddingInline: '$4',
  maxWidth: '90vw',
  boxShadow: '0 0 $space$4 0 $colors$shadows',
});

export function Tooltip(props: TooltipProps) {
  const { css, children, root, options } = props;

  const [tooltip, setTooltip] = useState<HTMLDivElement | null>();
  const { styles, attributes } = usePopper(root, tooltip, options);

  return (
    <TooltipRoot
      ref={useCallback((el: HTMLDivElement) => {
        if (el) setTooltip(el);
      }, [])}
      aria-live="polite"
      role="tooltip"
      css={css}
      style={styles.popper}
      {...attributes.popper}
    >
      {children}
    </TooltipRoot>
  );
}
